import { render, staticRenderFns } from "./family.vue?vue&type=template&id=2982f571&scoped=true&"
import script from "./family.vue?vue&type=script&lang=js&"
export * from "./family.vue?vue&type=script&lang=js&"
import style0 from "./family.vue?vue&type=style&index=0&id=2982f571&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2982f571",
  null
  
)

export default component.exports